// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1ukgB","Success":"Button_Success__2Htdn","Danger":"Button_Danger__1S26V"};